import * as React from 'react';
import { useState } from 'react';
import {
  Avatar,
  Button,
  Card,
  CardActions,
  CircularProgress,
  Box,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import {
  Form,
  required,
  TextInput,
  useTranslate,
  useLogin,
  useNotify,
} from 'react-admin';
import { useLocation } from 'react-router-dom';

interface FormValues {
  username?: string;
  password?: string;
}

const Login = () => {
  const [loading, setLoading] = useState(false);
  const translate = useTranslate();
  const notify = useNotify();
  const login = useLogin();
  const location = useLocation();

  const handleSubmit = (auth: FormValues) => {
    setLoading(true);
    login(auth, location.state ? (location.state as any).nextPathname : '/')
      .catch((error: Error) => {
        setLoading(false);
        notify(error?.message || 'Login failed', { type: 'error' });
      });
  };

  return (
    <Form onSubmit={handleSubmit} noValidate>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
        }}
      >
        <Card sx={{ minWidth: 360, p: 1 }}>
          <Box sx={{ margin: '1em', display: 'flex', justifyContent: 'center' }}>
            <Avatar sx={{ bgcolor: 'secondary.main' }}>
              <LockIcon />
            </Avatar>
          </Box>
          <Box sx={{ px: 2, pb: 1, textAlign: 'center', color: 'text.secondary' }}>
            Credco Marketing Admin
          </Box>
          <Box sx={{ padding: '0 1em 1em 1em' }}>
            <TextInput
              autoFocus
              source="username"
              label={translate('ra.auth.username')}
              disabled={loading}
              validate={required()}
              fullWidth
            />
            <Box sx={{ mt: 2 }}>
              <TextInput
                source="password"
                label={translate('ra.auth.password')}
                type="password"
                disabled={loading}
                validate={required()}
                fullWidth
              />
            </Box>
          </Box>
          <CardActions sx={{ padding: '0 1em 1em 1em' }}>
            <Button variant="contained" type="submit" color="primary" disabled={loading} fullWidth>
              {loading ? <CircularProgress size={25} thickness={2} /> : translate('ra.auth.sign_in')}
            </Button>
          </CardActions>
        </Card>
      </Box>
    </Form>
  );
};

export default Login;
